import { useState, useEffect } from 'react';
import { Typography } from '@/lib/typography';
import { SquaresFour } from '@phosphor-icons/react';
import { IntelligencePanel } from '@/components/dashboard/IntelligencePanel';
import { ActivityFeed } from '@/components/dashboard/ActivityFeed';
import { PipelineVelocityChart } from '@/components/dashboard/charts/PipelineVelocityChart';
import { ConversionFunnelChart } from '@/components/dashboard/charts/ConversionFunnelChart';
import { ResponseRateChart } from '@/components/dashboard/charts/ResponseRateChart';
import SystemStatusCard from '@/components/dashboard/SystemStatusCard';
import { renderCheckpoint } from '@/utils/renderCheckpoint';

export default function Dashboard() {
  const [showAlertsBanner, setShowAlertsBanner] = useState(true);

  useEffect(() => {
    console.log('dashboard_viewed'); // # nolint
    renderCheckpoint(4, 'Page Content Render (Dashboard)');
  }, []);

  const handleDismissAlerts = () => {
    console.log('alerts_banner_dismissed'); // # nolint
    setShowAlertsBanner(false);
  };

  return (
    <div className="min-h-screen bg-canvas-base" data-testid="dashboard-page">
      <div className="container mx-auto p-8">
        <div className="mb-8 flex justify-between items-start">
          {/* Header with Icon */}
          <div className="flex items-center gap-4">
            <SquaresFour className="h-10 w-10 text-brand-900" />
            <div>
              <h1 className={Typography.h1}>
                Dashboard
              </h1>
              <p className="text-slate-500">
                Strategic insights and pipeline overview
              </p>
            </div>
          </div>

          <div className="w-80">
            <SystemStatusCard />
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
          <PipelineVelocityChart />
          <ConversionFunnelChart />
          <ResponseRateChart />
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
          <IntelligencePanel />
          <ActivityFeed />
        </div>
      </div>
    </div>
  );
}
